module.exports = __webpack_public_path__ + "img/loading.aed0c5e0.gif";